import { observer } from "mobx-react-lite";
import { useTranslations } from "next-intl";

import { NodeTextField } from "@/components/doc/right-sidebar/active-node-style/fields/NodeTextField";
import { setNodeName } from "@/components/doc/right-sidebar/node-viewer/utils";
import { twMerge } from "@/utils/twMerge";

import type { ConstantNodeModel } from "@/models/nodes/ConstantNodeModel";
import type { VariableNodeModel } from "@/models/nodes/VariableNodeModel";

type Props = {
  node: VariableNodeModel | ConstantNodeModel;
  className?: string;
};

export const NodeNameField = observer(function NodeNameField({ node, className }: Props) {
  const t = useTranslations("sidebar.activeNode");

  const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setNodeName(node, e.target.value);
  };

  return (
    <NodeTextField
      id={`name-${node.id}`}
      value={node.name}
      name={t("fields.name")}
      onChange={handleOnChange}
      labelProps={{
        className: twMerge("shadow-block dark:shadow-block-inverted", className),
        label: t("fields.name"),
      }}
    />
  );
});
